import { Component } from '@angular/core';
import { RepositoryService } from './../../shared/services/repository.service';
import { RiskUser } from './../../_interfaces/RiskUser.model';
import { Router } from '@angular/router';
import { AlertService } from 'src/app/shared/services/alert.service';
import { map, shareReplay } from 'rxjs/operators';
import { Observable } from 'rxjs';


@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css']
})
export class UserListComponent {
  public users: RiskUser[];

  constructor(
    private repository: RepositoryService,
    private router: Router,
    private alert: AlertService
  ) { }

  readonly USER_ENDPOINT = 'Users';

  allUsers$: Observable<RiskUser[]> = this.repository.getData(this.USER_ENDPOINT).pipe(
    shareReplay(1),
    map(res => res as RiskUser[])
  );

  filterUsers$: Observable<RiskUser[]> = this.allUsers$;

  allUsers() {
    this.filterUsers$ = this.allUsers$;
  }

  latestUsers() {
    this.filterUsers$ = this.allUsers$.pipe(
      map((users: RiskUser[]) => {
        let filterDate = new Date();
        filterDate.setDate(filterDate.getDate() - 7);
        return users.filter((user: RiskUser) => new Date(user.createdAt) > filterDate);
      })
    );
  }

  public SyncUsers() {
    this.repository.create("users/SyncUsers", null).subscribe(
      (createdUsers: RiskUser[]) => {
        if (createdUsers === null || createdUsers.length === 0) {
          this.alert.info("No new users found");
        } else {
          const itemDescription = createdUsers.length === 1 ? 'user' : 'users'; 
          this.alert.success(`${createdUsers.length} ${itemDescription} added`);
        }
    }, (error) => {
      this.alert.error("An error occured. " + error.message, false); 
    });
  }

  public editUserRecord(userId: number) {
    let riskUserUrl: string = `/myrisks/edit-user/${userId}`;
    this.router.navigate([riskUserUrl]);
  }
}
